import { render, staticRenderFns } from "./AcsSettingsView.vue?vue&type=template&id=30ceef20&scoped=true"
import script from "./AcsSettingsView.vue?vue&type=script&lang=js"
export * from "./AcsSettingsView.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/college/PlaceListView.css?vue&type=style&index=0&id=30ceef20&prod&scoped=true&lang=css&external"
import style1 from "./AcsSettingsView.vue?vue&type=style&index=1&id=30ceef20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ceef20",
  null
  
)

export default component.exports